import { Facebook, Mail, Link2, X as XIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ShareButtons({ car }) {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const title = car ? `${car.year} ${car.make} ${car.model} — Pit Stop Motors` : "Pit Stop Motors";

  const fbHref = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const xHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
  const mailHref = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(
    `Check out this vehicle at Pit Stop Motors:\n\n${title}\n${url}`
  )}`;

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    toast.success("Link copied to clipboard");
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      <span className="text-xs uppercase tracking-wider text-muted-foreground mr-1">Share</span>
      <Button asChild size="icon" variant="outline" className="rounded-sm h-9 w-9" aria-label="Share on Facebook">
        <a href={fbHref} target="_blank" rel="noreferrer" data-testid="share-facebook">
          <Facebook className="h-4 w-4" />
        </a>
      </Button>
      <Button asChild size="icon" variant="outline" className="rounded-sm h-9 w-9" aria-label="Share on X">
        <a href={xHref} target="_blank" rel="noreferrer" data-testid="share-x">
          <XIcon className="h-4 w-4" />
        </a>
      </Button>
      <Button asChild size="icon" variant="outline" className="rounded-sm h-9 w-9" aria-label="Share via email">
        <a href={mailHref} data-testid="share-email">
          <Mail className="h-4 w-4" />
        </a>
      </Button>
      <Button onClick={copyLink} size="icon" variant="outline" className="rounded-sm h-9 w-9" aria-label="Copy link" data-testid="share-copy">
        <Link2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
